import {
  ComputeMonthTermFrequencyDto,
  ComputeMonthlyTermsResponseDto,
} from '@src/data/types/ComputeMonthTermFrequencyDto'
import { getApiClient } from '@src/services/api-client'
import { useQuery } from '@tanstack/react-query'

export const computeMonthlyTerms = async (
  financingProgramId: string,
  dto: ComputeMonthTermFrequencyDto | undefined,
): Promise<ComputeMonthlyTermsResponseDto> => {
  const apiClient = getApiClient()
  const response = await apiClient.post<ComputeMonthlyTermsResponseDto>(
    `/Applications/${financingProgramId}/CalculateMonthlyTerms`,
    dto,
  )
  return response.data
}

export const useComputeMonthlyTerms = (
  financingProgramId: string,
  dto: ComputeMonthTermFrequencyDto | undefined,
): [ComputeMonthlyTermsResponseDto | null, boolean] => {
  const { isFetching, data } = useQuery({
    queryKey: ['monthlyTerms', financingProgramId, dto],
    queryFn: () => computeMonthlyTerms(financingProgramId, dto),
    enabled: !!financingProgramId && !!dto && !!dto.paymentPlanId && dto.amountRequested > 0,
  })

  return [data ?? null, isFetching]
}

export function extractTerms(response: ComputeMonthlyTermsResponseDto): {
  validTerms: number[]
  invalidTerms: Map<number, string>
} {
  const validTerms = response?.monthlyTerms?.map((t) => t.term) ?? []
  const invalidTerms = new Map(response?.invalidTerms?.map((t) => [t.term, t.reason]) ?? [])
  return { validTerms, invalidTerms }
}
